export default __webpack_public_path__ + "static/media/view_more_btn.2344687e.svg";